'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _enhancers = require('../enhancers');

var enhancers = _interopRequireWildcard(_enhancers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enhancersArray = Object.keys(enhancers).map(function (key) {
  return enhancers[key];
});

var propTypes = enhancersArray.reduce(function (memo, _ref) {
  var propTypes = _ref.propTypes;

  if (propTypes) memo = _extends({}, memo, propTypes);
}, {
  onRef: _propTypes2.default.func,
  is: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func])
});

var parseProps = function parseProps(props) {
  return enhancersArray.reduce(function (props, _ref2) {
    var parseProps = _ref2.parseProps;

    if (parseProps) props = parseProps(props);
    return props;
  }, props);
};

var n = 'ui-lib-box';

// Add these styles globally until glamor properly supports &:matches

_glamor.css.global('article.' + n + ', aside.' + n + ', details.' + n + ', figcaption.' + n + ', figure.' + n + ', footer.' + n + ', header.' + n + ', hgroup.' + n + ', menu.' + n + ', nav.' + n + ', section.' + n, {
  display: 'block'
});

_glamor.css.global('ol.' + n + ', ul.' + n, {
  listStyle: 'none'
});

_glamor.css.global('bloquote.' + n + ', q.' + n, {
  quotes: 'none'
});

_glamor.css.global('table.' + n, {
  borderCollapse: 'collapse',
  borderSpacing: '0'
});

_glamor.css.global('input.' + n + ', textarea.' + n, {
  outline: 'none'
});

_glamor.css.global('strong.' + n, {
  fontWeight: '500'
});

_glamor.css.global('em.' + n, {
  fontStyle: 'italic'
});

_glamor.css.global('*.' + n + ', *.' + n + ':before, *.' + n + ':after', {
  boxSizing: 'border-box'
});

var cssBaseStyles = (0, _glamor.css)({
  margin: '0',
  padding: '0',
  border: '0',
  verticalAlign: 'baseline',
  MozOsxFontSmoothing: 'grayscale',
  WebkitFontSmoothing: 'antialiased',
  fontSmoothing: 'antialiased'
});

var Box = function (_React$Component) {
  _inherits(Box, _React$Component);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          is = _props.is,
          theme = _props.theme,
          onRef = _props.onRef,
          restProps = _objectWithoutProperties(_props, ['is', 'theme', 'onRef']); // eslint-disable-line


      var _parseProps = parseProps(restProps),
          className = _parseProps.className,
          parsedProps = _objectWithoutProperties(_parseProps, ['className']);

      return _react2.default.createElement(is, _extends({}, parsedProps, {
        className: (0, _classnames2.default)(n, '' + cssBaseStyles, className)
      }, onRef ? {
        ref: function ref(node) {
          onRef(node);
        }
      } : {}));
    }
  }]);

  return Box;
}(_react2.default.Component);

Box.propTypes = propTypes;

Box.defaultProps = {
  is: 'div'
};

Box.displayName = 'Box';

exports.default = Box;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Box.js
// module id = 55
// module chunks = 0